import { render, staticRenderFns } from "./RoofCalLogo.vue?vue&type=template&id=064d5a38&scoped=true"
import script from "./RoofCalLogo.vue?vue&type=script&lang=js"
export * from "./RoofCalLogo.vue?vue&type=script&lang=js"
import style0 from "./RoofCalLogo.vue?vue&type=style&index=0&id=064d5a38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d5a38",
  null
  
)

export default component.exports